import * as React from 'react';

const MailChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 9.9V16H6V9.9l6 4.3 6-4.3zM6.7 8h10.6L12 11.8 6.7 8zM4 18h16V6H4v12z"
        />
    </svg>
);

MailChunkySvg.displayName = 'MailChunkySvg';
export default MailChunkySvg;
